/******************************************************************************
 *** BgtSpcDpstImplInq ** 특별회계기금 * 수입/지출결의서 결재완료 조회
*******************************************************************************/
import React from "react";
import Util from "@/js/common/Util";
import SelectBox from "@/js/common/ui/input/SelectBox";
import StyledTabs from "@/js/common/ui/StyledTabs";
import { Tab, TabList, TabPanel } from "react-tabs";
import { useRecoilValue } from "recoil";
import * as Atom from "@/js/common/Atom";
import TextBox from "@/js/common/ui/input/TextBox";
import BgtSpcImplDpstList from "./BgtBrImplDpstList";
import BgtSpcImplExpndList from "./BgtBrImplExpndList";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import AppContext from "@/js/common/AppContext";

interface Props {
    systemCode: string;
}

const BgtSpcDpstImplInq = ( {systemCode}: Props ) => {
    const userInfo = useRecoilValue(Atom.userInfo);
    // 검색 조건
    const [upOgnzCd      , setUpOgnzCd      ] = React.useState<string>(userInfo.upOgnzCd);      // 상위조직코드(본부)
    const [ognzCd        , setOgnzCd        ] = React.useState<string>(userInfo.ognzCd  );      // 조직코드(지부)
    const [acntgYear     , setAcntgYear     ] = React.useState<string>(Util.getNowAcntgYear()); // 회계연도
    const [searchKywd    , setSearchKywd    ] = React.useState<string>("");                     // 검색어(적요)
    const [dataSbmsnCmptnYn, setDataSbmsnCmptnYn] = React.useState("");
    const [expndRsdocSeCd, setExpndRsdocSeCd] = React.useState("");
    const [acntgMonth      , setAcntgMonth      ] = React.useState<string>(""); // 월별 조회
    const [keyword, setKeyword] = React.useState(""); // 검색어(문서 ID)
    // 관/항/목
    const [bgtSbjct1stCd, setBgtSbjct1stCd] = React.useState<string>("");
    const [bgtSbjct2stCd, setBgtSbjct2stCd] = React.useState<string>("");
    const [bgtSbjct3stCd, setBgtSbjct3stCd] = React.useState<string>("");
    
    // 수입일자/행위년월일 
    const [sttDt, setSttDt] = React.useState<string>(""); // 시작일자
    const [endDt, setEndDt] = React.useState<string>(""); // 종료일자
    // Tabs
    const [tabIndex, setTabIndex] = React.useState<number>(0); // 0: 수입, 1: 지출

    const changeTab = (index: number) => {
        setBgtSbjct1stCd("");
        setBgtSbjct2stCd("");
        setBgtSbjct3stCd("");
        setTabIndex(index);
    };

    // 특별회계기금 타이틀 설정
    const [systemName, setSystemName] = React.useState<string>("");

    // 특별회계기금 타이틀 설정
    React.useEffect(() => {
        if (systemCode === "E1") {
            setSystemName("지부 운영비");
        } else if (systemCode === "F1") {
            setSystemName("지부장 직무활동비");
        } else if (systemCode === "G1") {
            setSystemName("지부 대회비");
        }
    }, [systemCode]);

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            {/* 타이틀 */}
            <div className="mt5">
                <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">{systemName} 결재완료 조회</span>
                <div className="bdt3 bdc007bff pb10" />
            </div>

            {/* 검색 영역 */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC flxWrap gap14">
                    {/* 소속 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox value={upOgnzCd}
                            width={150} height={36} fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setUpOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    {/* 지부 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox value={ognzCd}
                            width={180} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getDownOrgCodeArray(upOgnzCd)}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    {/* 회계연도 */}
                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">회계연도</span>
                        <SelectBox value={acntgYear}
                            width={120} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff" paddingRight={8}
                            codeArray={Util.getAcntgYearArray()}
                            placeholder="선택"
                            onChangeFunc={(data: string) => setAcntgYear(data)}
                        />
                    </div>

                    {/* 문서 번호 */}
                    <div className="dpFlx aiC">
                        <span className="w70 fm-c fs15 fc333333 ls1 taL">문서번호</span>
                        <TextBox value={keyword} 
                            width={180} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333"
                            letterSpacing={-1} borderColor="#ddd"
                            borderOnColor="#222" borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 12px" }}
                            placeholder="예: 2026_03_001"
                            onChangeFunc={(t: string) => setKeyword(t)}
                        />
                    </div>

                    {/* 월별 조회 */}
                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">월별 조회</span>
                        <SelectBox value={acntgMonth}
                            width={140} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff" paddingRight={8}
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("SRCH_MM"))}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setAcntgMonth(data)}
                        />
                    </div>

                    {/* 적요 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">적요</span>
                        <TextBox value={searchKywd}
                            width={200} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 12px" }}
                            placeholder="검색어 입력"
                            onChangeFunc={(text: string) => setSearchKywd(text)}
                        />
                    </div>

                    {/* 작성일자 기간 */}
                    <div className="dpFlx aiC">
                        <span className="w90 fm-c fs15 fc333333 ls1 taL">{tabIndex === 0 ? "수입일자" : "행위년월일"}</span>
                        <DatePickerBox value={sttDt}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            bgColor="white" textAlign="left"
                            calendarThemeColor={AppContext.themeColor}
                            className="mr5"
                            onChange={(data: string) => setSttDt(data)}
                        />
                        <span className="fm-c fc666666 mr5">~</span>
                        <DatePickerBox value={endDt}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            bgColor="white" textAlign="left"
                            calendarThemeColor={AppContext.themeColor}
                            className="mr5"
                            onChange={(data: string) => setEndDt(data)}
                        />
                    </div>

                    {/* 지출결의서 구분 */}
                    {tabIndex === 1 && (
                        <div className="dpFlx aiC">
                        <span className="w90 fm-c fs15 fc333333 ls1 taL">결의서 구분</span>
                        <SelectBox value={expndRsdocSeCd}
                            width={140} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333"
                            letterSpacing={-1} borderColor="#ddd"
                            borderOnColor="#222" borderRadius={2} background="#fff"
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("EXPND_RSDOC_SE_CD"))}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(v: string) => {
                                setExpndRsdocSeCd(v);
                                if (v !== "02") setDataSbmsnCmptnYn("");
                            }}
                        />
                        </div>
                    )}

                    {/* 자료제출 여부 */}
                    {tabIndex === 1 && expndRsdocSeCd === "02" && (
                        <div className="dpFlx aiC">
                            <span className="w100 fm-c fs15 fc333333 ls1 taL">자료제출 여부</span>
                            <SelectBox value={dataSbmsnCmptnYn}
                                width={120} height={36}
                                fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                                borderColor="#ddd"
                                borderOnColor="#222"
                                borderRadius={2}
                                background="#fff"
                                codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("UI_SBMSN_YN_01"))}
                                placeholder="전체"
                                paddingRight={8}
                                onChangeFunc={(v: string) => setDataSbmsnCmptnYn(v)}
                            />
                        </div>
                    )}

                    <div className="dpFlx aiC flxWrap gap14">
                        {/* 관 */}
                        <div className="dpFlx aiC">
                            <span className="w40 fm-c fs15 fc333333 ls1 taL">관</span>
                            <SelectBox
                                value={bgtSbjct1stCd}
                                width={160}
                                height={36}
                                fontSize={14}
                                fontFamily="fm-c"
                                color="#333"
                                letterSpacing={-1}
                                borderColor="#ddd"
                                borderOnColor="#222"
                                borderRadius={2}
                                background="#fff"
                                codeArray={[{ code: "", name: "전체" }].concat(Util.getSpcBgt1CodeArray(systemCode, tabIndex === 0 ? "01" : "02"))}
                                placeholder="선택"
                                paddingRight={8}
                                onChangeFunc={(v: string) => {
                                setBgtSbjct1stCd(v);
                                setBgtSbjct2stCd("");
                                setBgtSbjct3stCd("");
                                }}
                            />
                        </div>

                        {/* 항 */}
                        <div className="dpFlx aiC">
                            <span className="w40 fm-c fs15 fc333333 ls1 taL">항</span>
                            <SelectBox
                                value={bgtSbjct2stCd}
                                width={180}
                                height={36}
                                fontSize={14}
                                fontFamily="fm-c"
                                color="#333"
                                letterSpacing={-1}
                                borderColor="#ddd"
                                borderOnColor="#222"
                                borderRadius={2}
                                background="#fff"
                                codeArray={[{ code: "", name: "전체" }].concat(Util.getSpcBgt2CodeArray(systemCode, bgtSbjct1stCd))}
                                placeholder="선택"
                                paddingRight={8}
                                onChangeFunc={(v: string) => {
                                setBgtSbjct2stCd(v);
                                setBgtSbjct3stCd("");
                                }}
                            />
                        </div>

                        {/* 목 */}
                        <div className="dpFlx aiC">
                            <span className="w40 fm-c fs15 fc333333 ls1 taL">목</span>
                            <SelectBox
                                value={bgtSbjct3stCd}
                                width={220}
                                height={36}
                                fontSize={14}
                                fontFamily="fm-c"
                                color="#333"
                                letterSpacing={-1}
                                borderColor="#ddd"
                                borderOnColor="#222"
                                borderRadius={2}
                                background="#fff"
                                codeArray={[{ code: "", name: "전체" }].concat(Util.getSpcBgt3CodeArray(systemCode, bgtSbjct2stCd))}
                                placeholder="선택"
                                paddingRight={8}
                                onChangeFunc={(v: string) => setBgtSbjct3stCd(v)}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* 탭 */}
            <StyledTabs selectedIndex={tabIndex} className="mb10 tabFit">
                <TabList>
                    <Tab onClick={() => changeTab(0)}>수입 결의서</Tab>
                    <Tab onClick={() => changeTab(1)}>지출 결의서</Tab>
                </TabList>

                {/* ========================= 수입 탭 ========================= */}
                <TabPanel>
                    <BgtSpcImplDpstList
                        ognzCd         = {ognzCd}       // 조직
                        acntgYear      = {acntgYear}    // 회계연도
                        systemCode     = {systemCode}   // 시스테코드
                        keyword        = {keyword         } // 검색어(문서번호)
                        searchKywd     = {searchKywd}   // 검색어(적요)
                        sttDt            = {sttDt           } // 검색 시작일(수입일자 기준)
                        endDt            = {endDt           } // 검색 종료일(수입일자 기준)
                        setEndDt         = {setEndDt        } // set 검색 종료일(초기화 프롭스)
                        acntgMonth       = {acntgMonth      } // 월별 조회
                        bgtSbjct1stCd    = {bgtSbjct1stCd   } // 관 코드
                        bgtSbjct2stCd    = {bgtSbjct2stCd   } // 항 코드
                        bgtSbjct3stCd    = {bgtSbjct3stCd   } // 목 코드
                    ></BgtSpcImplDpstList>
                </TabPanel>

                {/* ========================= 지출 탭 ========================= */}
                <TabPanel>
                    <BgtSpcImplExpndList
                        ognzCd         = {ognzCd}       // 조직
                        acntgYear      = {acntgYear}    // 회계연도
                        systemCode     = {systemCode}   // 시스테코드
                        keyword        = {keyword         } // 검색어(문서번호)
                        searchKywd     = {searchKywd}   // 검색어(적요)
                        dataSbmsnCmptnYn = {dataSbmsnCmptnYn} // 자료제출 여부
                        expndRsdocSeCd   = {expndRsdocSeCd}  // 결의서 구분
                        sttDt            = {sttDt           } // 검색 시작일(수입일자 기준)
                        endDt            = {endDt           } // 검색 종료일(수입일자 기준)
                        setEndDt         = {setEndDt        } // set 검색 종료일(초기화 프롭스)
                        acntgMonth       = {acntgMonth      } // 월별 조회
                        bgtSbjct1stCd    = {bgtSbjct1stCd   } // 관 코드
                        bgtSbjct2stCd    = {bgtSbjct2stCd   } // 항 코드
                        bgtSbjct3stCd    = {bgtSbjct3stCd   } // 목 코드
                    ></BgtSpcImplExpndList>
                </TabPanel>
            </StyledTabs>
        </div>
    );
};

export default BgtSpcDpstImplInq;